import { useEffect, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import PromoProductForm from "./PromoProductForm";
import AddProductModal from "./AddProductModal";
import DataTable from 'react-data-table-component';
import { PromoTemplates } from "./PromoTemplates";
import { PromoToolbar, PromoDisplay } from "./PromoToolbar";
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';
import 'bootstrap/dist/css/bootstrap.min.css';



const PromoEditor = () => {

    // Set state variables
    const { instance } = useMsal();
    const location = useLocation()['state'];
    console.log(location);
    const promoDatabaseId = location.promoDatabaseId;
    // Set the promoId
    const [promoId, setPromoId] = useState(location.promoId ? location.promoId : '');
    // Set the name of the promotion
    const [name, setName] = useState(location.name ? location.name : 'NEW IN STORE PROMOTION');
    const [startDate, setStartDate] = useState(location.startDate ? location.startDate : '');
    const [endDate, setEndDate] = useState(location.endDate ? location.endDate : '');
    const [products, setProducts] = useState(location.products ? location.products : []);
    const [template, setTemplate] = useState(location.template ? location.template : 'standard');

    const [tempSettings, setTempSettings] = useState({
        "promoId": promoId,
        "name": name,
        "startDate": startDate,
        "endDate": endDate
    });
      
    // Add this function to handle saving promo changes
    const handleSavePromoChanges = () => {
        // Update local state
        setPromoId(tempSettings.promoId);
        setName(tempSettings.name);
        setStartDate(tempSettings.startDate);
        setEndDate(tempSettings.endDate);
        
        // Update backend
        authFetch(instance, '/api/update_promo', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            promoDatabaseId: promoDatabaseId,
            promoId: tempSettings.promoId,
            name: tempSettings.name,
            startDate: tempSettings.startDate,
            endDate: tempSettings.endDate
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
            alert('Promo updated successfully');
            } else {
            alert('Error updating promo: ' + data.error);
            }
        })
        .catch(error => {
            console.error('Error:', error);
            alert('Error updating promo');
        });
    };

    // Handle showing or hiding text input for name and promo ID
    const [showNameInput, setShowNameInput] = useState(false);
    const handleSettingsChange = (update=false) => {
        console.log(showNameInput, update)
        if (showNameInput && update) {
            // Save the name and promo ID to the database
            authFetch(instance, '/api/update_promo', {
                "method": "POST",
                "headers": {"Content-Type": "application/json"},
                "body": JSON.stringify({"promoDatabaseId": promoDatabaseId, "promoId": tempSettings.promoId, "name": tempSettings.name, "startDate": tempSettings.startDate, "endDate": tempSettings.endDate, "template": template})
            })
            .then(resp => resp.json())
            .then(data => {
                console.log(data);
            });
            setPromoId(tempSettings.promoId);
            setName(tempSettings.name);
            setStartDate(tempSettings.startDate);
            setEndDate(tempSettings.endDate);
            setTempSettings({"promoId": promoId, "name": name, "startDate": startDate, "endDate": endDate})
            setShowNameInput(false);
        } else if (showNameInput && !update) {
            // Discard the changes
            setTempSettings({"promoId": promoId, "name": name, "startDate": startDate, "endDate": endDate})
            setShowNameInput(false);
        } else {
            setShowNameInput(true);
        }
    }

    const [currentProduct, setCurrentProduct] = useState({});
    const [showModal, setShowModal] = useState(false);
    // Handle adding a new product
    const handleAddProduct = () => {
        const newProduct = {
            promoDatabaseId: promoDatabaseId,
            productName: "",
            sku: "",
            bullet1: "",
            bullet2: "",
            bullet3: "",
            bullet4: "",
            bullet5: "",
            regular_price: "",
            sale_price: "",
            image1: null,
            image2: null,
            image3: null,
            image4: null,
            isNew: true,
            saveCircle: "",
            save_cirlce: "",
            print_promo_id: ""
        };
        //setProducts([...products, newProduct]);
        setCurrentProduct(newProduct);
    };

    const handleSaveNewProduct = (product) => {
        setProducts([...products, product]);
        setCurrentProduct({});
    }

    const handleEditProduct = (updatedProduct) => {
        // Find the product in the products array and replace it
        const updatedProducts = products.map(product => 
            product.productId === updatedProduct.productId ? updatedProduct : product
        );
        
        // Update the products state
        setProducts(updatedProducts);
        
        // Clear the current product
        setCurrentProduct({});
    }

    const handleProductsChange = (event) => {
        const { target: {name, value} } = event;
        console.log(products);
        console.log(name, value);
        setCurrentProduct({...currentProduct, [name]: value})
        //setProducts({...products, [name]: value});
    }

    const handlePrintPromos = () => {
        console.log('Print Promos');
        console.log(products);
        authFetch(instance, '/api/print_promos', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"products": products, "template": template, "sale_id": promoId, "sale_end_date": endDate})
        })
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = `${promoId}.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(() => alert('Error processing PDF'));
    }

    const handleDeleteProduct = (productId) => {
        if (window.confirm("Are you sure you want to delete this product?")) {
          authFetch(instance, `/api/delete_promo_product/${productId}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ promoDatabaseId: promoDatabaseId })
          })
          .then(response => response.json())
          .then(data => {
            if (data.success) {
              // Remove the product from the products array
              setProducts(products.filter(product => product.productId !== productId));
              
              // If the deleted product was being edited, clear the form
              if (currentProduct.productId === productId) {
                setCurrentProduct({});
              }
            } else {
              alert("Error deleting product: " + data.error);
            }
            })
            .catch(error => {
            console.error('Error:', error);
            alert("Error deleting product");
            });
        }
    };

      const columns = [
        {
            selector: row => row.productName,
            grow: 1
        },
        {
            cell: row => (
                <Button 
                variant="danger" 
                size="sm"
                onClick={(e) => {
                    e.stopPropagation(); // Prevent row click event
                    handleDeleteProduct(row.productId);
                }}
                >
                Delete
                </Button>
            ),
            width: '100px',
            style: {
                justifyContent: 'flex-end'
            }
        }
    ]

    useEffect(() => {
        console.log(showNameInput)
    }, [showNameInput])



    return (
        <Container style={{
            marginBottom: '200px'
        }}>
            {showNameInput
            ? <PromoToolbar
                /*promoId={promoId}
                setPromoId={setPromoId}
                name={name}
                setName={setName}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}*/
                tempSettings={tempSettings}
                setTempSettings={setTempSettings}
                template={template}
                setTemplate={setTemplate}
                handlePrintPromos={handlePrintPromos}
                handleSavePromoChanges={handleSavePromoChanges}
            />
            : <PromoDisplay
                promoId={promoId}
                name={name}
                startDate={startDate} 
                endDate={endDate}
                template={template}
                setTemplate={setTemplate}
                handlePrintPromos={handlePrintPromos}
            />
            }
            <Row className="text-start d-flex justify-content-start align-items-center mt-3">
                <Col xs={2}>
                <Button style={{
                    backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21",
                    borderRadius: "0px",
                    borderColor: "#a73c21"
                }}
                onClick={() => handleSettingsChange(showNameInput)}
                >{!showNameInput
                    ? "Edit Promo Information"
                    : "Save Changes"
                }</Button>
                </Col>
                {showNameInput ?
                    <Col xs={2}>
                        <Button style={{
                            backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21",
                            borderRadius: "0px",
                            borderColor: "#a73c21"
                        }}
                        onClick={() => setShowNameInput(!showNameInput)}
                        >Cancel Changes</Button>
                    </Col>
                    : <></>
                }
            </Row>
            <hr/>
            <Row>
                <Col xs={6}>
                    <Row className="text-center">
                        <Button
                        onClick={() => handleAddProduct()}
                        style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            width: '80%',
                            backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21",
                            borderRadius: "0px",
                            borderColor: "#a73c21"
                        }}>Add Product</Button>
                    </Row>
                    <DataTable
                        customStyles={{
                            headRow: {
                                style: {
                                    marginTop: '-20px'
                                }
                            },
                            table: {
                                style: {
                                    marginTop: '0px'
                                }
                            }
                        }}
                        columns={columns}
                        data={products}
                        striped
                        noHeader={false}
                        onRowClicked={
                            (row) => {
                                currentProduct === row
                                ? setCurrentProduct({})
                                : setCurrentProduct(row)
                            }
                        }
                    />
                
                </Col>
                <Col xs={6} className="border-start">
                    <PromoProductForm
                        product={currentProduct}
                        setProduct={setCurrentProduct}
                        handleProductsChange={handleProductsChange}
                        promoDatabaseId={promoDatabaseId}
                        handleSaveNewProduct={handleSaveNewProduct}
                        handleEditProduct={handleEditProduct}
                        promoId={promoId}
                    />
                </Col>
                
            </Row>

            {/* Add Product Modal 
            <AddProductModal 
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleAdd={handleAddProduct}
            />*/}
        </Container>
    )
}

export default PromoEditor